import {
  REVIEW_SOFTSKILL_COURSE_USER,
  REVIEW_SOFTSKILL_COURSE_USER_SUCCESS,
  REVIEW_SOFTSKILL_COURSE_USER_CLEAN,
  REVIEW_SOFTSKILL_COURSE_USER_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  course: undefined,
}

const SoftskillCourseUserReview = (state = initialState, action) => {
  switch (action.type) {
    case REVIEW_SOFTSKILL_COURSE_USER:
      state = {
        ...state,
        loading: true,
      }
      break
    case REVIEW_SOFTSKILL_COURSE_USER_SUCCESS:
      state = {
        ...state,
        course: action.payload.course,
        loading: false,
        done: true,
      }
      break
    case REVIEW_SOFTSKILL_COURSE_USER_CLEAN:
      state = initialState
      break
    case REVIEW_SOFTSKILL_COURSE_USER_ERROR:
      state = { ...state, error: action.payload, loading: false, done: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default SoftskillCourseUserReview
